// extracted by mini-css-extract-plugin
module.exports = {"whiteColor":"#fff","borderGrey":"#e5e5e5","popupMenu":"PopupMenu_popupMenu__Z2sYE","menuButton":"PopupMenu_menuButton__3DBKj","menuList":"PopupMenu_menuList__262uD"};